import React, { useEffect, useState } from 'react';
import appData from '../data/data';
import ServiceModal from '../components/ServiceModal';
import { FaChartLine, FaLaptopCode } from 'react-icons/fa';

export default function Services() {
  const [modalService, setModalService] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <section className="section" style={{ paddingTop: '8rem' }}>
        <h1 className="section-title fade-in">Our Services</h1>
        <p className="section-subtitle fade-in">Comprehensive solutions for all your business needs</p>

        {/* 🔹 Tech Solutions Header */}
        <div className="services-category">
          <div className="category-header fade-in">
            <h3><FaLaptopCode /> Tech Solutions</h3>
            <p style={{ color: 'var(--text-dark)', marginTop: '.5rem' }}>
              Cutting-edge technology services to power your digital transformation
            </p>
          </div>

          {/* 🔹 Tech Services Cards */}
          <div className="card-grid-3">
            {appData.techServices.map((service, idx) => (
              <div
                key={idx}
                className="card fade-in"
                style={{ animationDelay: `${idx * 0.1}s` }}
                onClick={() => setModalService(service)}
              >
                <div className="card-icon"><service.Icon /></div>
                <h3 className="card-title">{service.name}</h3>
                <p className="card-description">{service.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 🔸 Non-Tech Solutions (No Change) */}
        <div className="services-category" style={{ marginTop: '5rem' }}>
          <div className="category-header fade-in">
            <h3><FaChartLine /> Non-Tech Solutions</h3>
            <p style={{ color: 'var(--text-dark)', marginTop: '.5rem' }}>
              Strategic business services to accelerate your growth
            </p>
          </div>

          <div className="card-grid-3">
            {appData.nonTechServices.map((service, idx) => (
              <div
                key={idx}
                className="card fade-in"
                style={{ animationDelay: `${idx * 0.1}s` }}
                onClick={() => setModalService(service)}
              >
                <div className="card-icon"><service.Icon /></div>
                <h3 className="card-title">{service.name}</h3>
                <p className="card-description">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {modalService && <ServiceModal service={modalService} onClose={() => setModalService(null)} />}
    </div>
  );
}